export function getParams(state) {
    return state.params
}

export function brandsList(state) {
    return state.brandsList;
}


// WEBPACK FOOTER //
// ./src/modules/brands/getters.js